import { GroupBase, StylesConfig } from "react-select";
import { FilterOption } from "./BaseFilters";

const BaseFiltersStyles: StylesConfig<
  FilterOption,
  boolean,
  GroupBase<FilterOption>
> = {
  control: (provided) => ({
    ...provided,
    borderRadius: 0,
    backgroundColor: "var(--color-white)",
    display: "flex",
    alignItems: "center",
    minHeight: "2.75rem",
    height: "auto",
    border: "1px solid var(--color-gray-4)",

    padding: "0.25rem 0.9375rem",
    "> div": {
      padding: 0,
    },
  }),
  menu: (provided) => ({
    ...provided,
    margin: 0,
    boxShadow: "none",
    border: "1px solid var(--color-gray-4)",
    borderTop: 0,
    borderRadius: 0,
    zIndex: 11,
  }),
  menuList: (provided) => ({
    ...provided,
    borderRadius: 0,
    backgroundColor: "var(--color-white)",
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    minHeight: "2.75rem",
    padding: "0.25rem 0.9375rem",
    borderBottom: "1px solid var(--color-gray-4)",
    backgroundColor: state.isSelected
      ? "var(--color-blue-2)"
      : state.isFocused
      ? "var(--color-gray-4)"
      : "transparent",
    "&:last-child": {
      borderBottom: 0,
    },
    "&:hover": {
      cursor: "pointer",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    maxWidth: "80%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
};

export default BaseFiltersStyles;
